import { WebStorageStateStore } from 'oidc-client-ts';

// Read from runtime config (window.ENV) if available, otherwise fall back to build-time env vars
export const getConfig = (key, defaultValue) => {
    return (window.ENV && window.ENV[key]) || process.env[key] || defaultValue;
};

const DEV_MODE = getConfig('REACT_APP_DEV_MODE', 'false').toLowerCase() === 'true';
const DISABLE_AUTH = getConfig('REACT_APP_DISABLE_AUTH', 'false').toLowerCase() === 'true';

export const oidcConfig = {
    // Используем реальный Identity Server
    authority: getConfig('REACT_APP_OIDC_AUTHORITY', 'https://id.icp.invent.us'),
    client_id: getConfig('REACT_APP_OIDC_CLIENT_ID', 'ac-upl'),
    redirect_uri: getConfig('REACT_APP_OIDC_REDIRECT_URI', window.location.origin),
    post_logout_redirect_uri: getConfig('REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI', window.location.origin),
    response_type: 'code',
    // Дополнительные параметры для обхода проблем с redirect_uri
    extraQueryParams: {
        prompt: 'login'
    },
    scope: getConfig('REACT_APP_OIDC_SCOPE', 'openid profile email api.default https://id.invent.us/data/catalog'),
    automaticSilentRenew: true,
    loadUserInfo: true, // Включаем автоматическое получение информации о пользователе
    userStore: new WebStorageStateStore({ store: window.localStorage }),

    // Callbacks for handling auth events
    onSigninCallback: () => {
        window.history.replaceState({}, document.title, window.location.pathname);
    },

    // Handle silent renewal errors
    onSigninSilentError: (error) => {
        console.error('Silent token renewal failed:', error);
        // User will be redirected to login by the API interceptor on next 401
    },
    metadata: {
        issuer: getConfig('REACT_APP_OIDC_AUTHORITY', 'https://id.icp.invent.us'),
        authorization_endpoint: getConfig('REACT_APP_OIDC_AUTHORITY', 'https://id.icp.invent.us') + '/connect/authorize',
        token_endpoint: getConfig('REACT_APP_OIDC_AUTHORITY', 'https://id.icp.invent.us') + '/connect/token',
        userinfo_endpoint: getConfig('REACT_APP_OIDC_AUTHORITY', 'https://id.icp.invent.us') + '/connect/userinfo',
        end_session_endpoint: getConfig('REACT_APP_OIDC_AUTHORITY', 'https://id.icp.invent.us') + '/connect/endsession',
        jwks_uri: getConfig('REACT_APP_OIDC_AUTHORITY', 'https://id.icp.invent.us') + '/.well-known/openid-configuration/jwks',
        scopes_supported: ['openid', 'profile', 'email', 'api.default', 'https://id.invent.us/data/catalog'],
        claims_supported: ['sub', 'name', 'preferred_username', 'email', 'tenant_id', 'tid']
    }
};

// Export dev mode configuration
export { DEV_MODE, DISABLE_AUTH };

